import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useTermination = (): ContextValue => useContext(Context);
